import React, { useEffect } from "react";
import { Chart } from "react-google-charts";
import { getGraphBackgroundColor } from "../../../../utils/utils";

const options: any = {
  hAxis: {
    textStyle: { fontSize: 14, color: "#333" },
  },
  vAxis: {
    ticks: [
      { v: 0, f: "None" },
      { v: 1, f: "Bad" },
      { v: 2, f: "Fair" },
      { v: 3, f: "Good" },
      { v: 4, f: "Excellent" },
    ],
    textStyle: { fontSize: 14, color: "#333" },
  },
  legend: { position: "none" },
};

const GradingScoresChart = ({grades, getGradings}: any) => {

  const gradings = ['Attendance', 'Attitude/Work Ethic', 'Site Feedback'];
  const data = [
    ["Grades", "", { role: "style" }],
    ...gradings.map((grade, i) => [
      grade,
      grades ? Math.round(grades[i]) : undefined,
      grades ? getGraphBackgroundColor(Math.round(grades[i])) : undefined,
    ]),
  ];

  useEffect(() => {
    getGradings()
  }, [])

  return (
    <Chart
      chartType="ColumnChart"
      width="100%"
      height="500px"
      data={data}
      options={options}
    />
  );
}

export default GradingScoresChart;
